import { LogIn } from 'lucide-react';
import { ApiError } from '../api/client';
import { useSignOut } from '../api/hooks';
import { useUI } from '../lib/ui';
import { forgetGoogleAutoSelect } from '../pages/SignInPage';

/** Sensitive account actions need a recent sign-in (sign-in servers only; never locally). */
export function isReauthRequired(err: unknown): err is ApiError {
  return err instanceof ApiError && err.code === 'reauth_required';
}

/** The server's reason, and a way back in: signing out lands on the sign-in page. */
export function ReauthPrompt({ message }: { message: string }) {
  const { toast } = useUI();
  const signOut = useSignOut();
  return (
    <div className="banner banner--warn" role="alert">
      <LogIn size={17} />
      <div className="stack" style={{ gap: 10 }}>
        <span className="small">{message}</span>
        {/* type="button": this prompt can sit inside a form (Add an email) and must not submit it. */}
        <button
          type="button"
          className="btn btn--primary btn--sm"
          style={{ alignSelf: 'flex-start' }}
          disabled={signOut.isPending}
          onClick={() => {
            forgetGoogleAutoSelect();
            signOut.mutate({}, { onError: (e) => toast(e.message, { tone: 'error' }) });
          }}
        >
          Sign in again
        </button>
      </div>
    </div>
  );
}
